import { render, staticRenderFns } from "./GeofenceEventsSettingModal.vue?vue&type=template&id=484c2411&scoped=true&"
import script from "./GeofenceEventsSettingModal.vue?vue&type=script&lang=js&"
export * from "./GeofenceEventsSettingModal.vue?vue&type=script&lang=js&"
import style0 from "./GeofenceEventsSettingModal.vue?vue&type=style&index=0&id=484c2411&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484c2411",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('484c2411')) {
      api.createRecord('484c2411', component.options)
    } else {
      api.reload('484c2411', component.options)
    }
    module.hot.accept("./GeofenceEventsSettingModal.vue?vue&type=template&id=484c2411&scoped=true&", function () {
      api.rerender('484c2411', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/GeofenceEventsSettingModal.vue"
export default component.exports